import {
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  SIGNOUT_SUCCESS,
  SIGNOUT_FAILED,
  SIGNUP_SUCCESS,
  SIGNUP_FAILED
} from "./types";

export const signIn = (creditials, props) => async dispatch => {
  try {
    await props.firebase
      .auth()
      .signInWithEmailAndPassword(creditials.email, creditials.password);
    dispatch({ type: LOGIN_SUCCESS });
  } catch (err) {
    dispatch({ type: LOGIN_ERROR, payload: err });
  }
};

export const signOut = props => async dispatch => {
  try {
    await props.firebase.auth().signOut();
    dispatch({ type: SIGNOUT_SUCCESS });
  } catch (err) {
    dispatch({ type: SIGNOUT_FAILED, err });
  }
};

export const signUp = (newUser, props) => async dispatch => {
  console.log("User", newUser, props);
  try {
    const res = await props.firebase
      .auth()
      .createUserWithEmailAndPassword(newUser.email, newUser.password);
    console.log("User2", res, res.user.uid);
    await props.firestore
      .collection("users")
      .doc(res.user.uid)
      .set({
        displayName: newUser.name,
        uid: res.user.uid,
        // createdAt: props.firestore.FieldValue.serverTimestamp(),
        provider: "signup"
      });
    dispatch({ type: SIGNUP_SUCCESS });
  } catch (err) {
    console.log(err);
    dispatch({ type: SIGNUP_FAILED, err });
  }
};

const loginMethod = (props, provider) => {
  props.firebase
    .auth()
    .signInWithPopup(provider)
    .then(function(result) {
      if (result.additionalUserInfo.isNewUser) {
        props.firestore
          .collection("users")
          .doc(result.user.uid)
          .set({
            displayName: result.user.displayName,
            email: result.user.email,
            uid: result.user.uid,
            photoURL: result.user.photoURL,
            createdAt: props.firestore.FieldValue.serverTimestamp(),
            provider: result.additionalUserInfo.providerId
          });
      }
    })
    .catch(function(error) {
      console.error(error);
    });
};

export const socialLogin = (selectedProvider, props) => dispatch => {
  try {
    if (selectedProvider === "google") {
      const provider = new props.firebase.auth.GoogleAuthProvider();

      loginMethod(props, provider);
    } else {
      const provider = new props.firebase.auth.FacebookAuthProvider();

      loginMethod(props, provider);
    }
  } catch (err) {
    console.error(err);
  }
};
